import { Modal, ModalContent } from '@braskai/ui-kit';

import type { ReactNode } from 'react';

import { HubSpotMeetings } from '@/shared/thirdParty/hubSpot';
import { ModalHeaderDefault } from '@/shared/ui/modal';

const TITLE = 'Book your 30-minute Rask demo';
const SUBTITLE = (
  <>
    You&apos;ll get a personalized walkthrough of the product, hear proven customer success
    <br />
    stories, and learn about pricing for your use case.
  </>
);

type DemoBookingCalendarModalProps = {
  email?: string;
  meetingUrl: string;
  secondaryAction?: ReactNode;
  onBooked: (startsAt?: Date) => void;
  onClose: () => void;
  onLoadError?: () => void;
};

export const DemoBookingCalendarModal = ({
  email,
  meetingUrl,
  secondaryAction,
  onBooked,
  onClose,
  onLoadError,
}: DemoBookingCalendarModalProps) => (
  <Modal
    PaperProps={{ sx: { height: 'calc(100dvh - 24px)', m: '12px', maxHeight: 'calc(100dvh - 24px)' } }}
    size="lg"
    // Must clear the raw MUI modals it can be opened from (trial paywall sits on zIndex.modal).
    sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    open
    onClose={onClose}
  >
    <ModalHeaderDefault title={TITLE} subtitle={SUBTITLE} onClose={onClose} />

    <ModalContent
      sx={{
        '& .meetings-iframe-container': { width: '100%' },
        '& .meetings-iframe-container iframe': { display: 'block', width: '100% !important' },
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
      }}
    >
      <HubSpotMeetings email={email} meetingUrl={meetingUrl} onBooked={onBooked} onLoadError={onLoadError} />

      {secondaryAction}
    </ModalContent>
  </Modal>
);
